import CustomSelect from "./CustomSelect.component.jsx";

export default CustomSelect;
